import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { VDSManager } from "@vds/utilities";
import "@vds-tokens/gen3/index.css";
import "@vds-tokens/core/index.css";
import {
	resetGlobalSlice,
	setClientId,
	setSessionCartData,
	setWidgetInputParams,
	setManageServiceInfo,
	initializeMfe
} from "app/ducks/GlobalSlice";

import {
	clear4g5gCart,
	resetQualificationSlice,
	setClear4g5gCartResp,
} from "pages/Qualification/ducks/QualificationSlice";
import SpinnerComponent from "common/components/Spinner/Spinner";
import "./WidgetsDecider.css";
import { resetBussProductsSlice } from "pages/BussProductsPage/ducks/BussProductSlice";
import { MarketplaceWidget } from "MarketplaceWidget";
import { MarketplaceGridwallWidget } from "MarketplaceGridwallWidget";
import { AddALineWidget } from "pages/AddALineWidget/AddALineWidget";
import { MarketplaceFWA } from "MarketPlaceFWA";
import { getMVBDetails, loadScript } from "app/ducks/utils";
import { getGeoLocation, resetCheckoutState } from "pages/Checkout/ducks/CheckoutSlice";
import { resetCreditSlice } from "pages/Checkout/CreditResult/CreditResultsNew/CreditSlice";
import { resetReviewSlice } from "pages/Checkout/ducks/ReviewSlice";
import { resetPaymentSlice } from "pages/Checkout/Payment/ducks/PaymentSlice";
import { resetLowerFunnelSlice } from "pages/CheckoutNew/ducks/LowerFunnelSlice";
import { MarketplaceWCMP } from "MarketPlaceWCMP";
import { resetAddonsState } from "pages/LandingAddons/ducks/LandingAddonsSlice";
import { loadChatScript } from "utils/commonUtils";
import { resetbulkUploadSlice } from "pages/BulkUpload/ducks/bulkUploadSlice";
import { WidgetRouter } from "WidgetRouter";
import { getAEMInformation, getFetchCart5G, getOrderQuoteFetchSavedCart } from "pages/ShoppingCart/ducks/ShoppingCartSlice";
import { globalData } from "pages/Checkout/ducks/selectors";

function WidgetsDecider(props) {
	const dispatch = useDispatch();
	const [showProspectWidgets, setShowProspectWidgets] = useState(false);
	const urlParams = new URLSearchParams(window.location.search);
	const pageNameParam = urlParams.get("pageName");
	const shoppingCartData = useSelector((state) => state.ProspectWidgets_ShoppingCartData);
	const lqData = useSelector((state) => state.ProspectWidgets_LQPage);
	const globalData = useSelector((state) => state.ProspectWidgets_GlobalData);
	const retrieve = props?.inputAttributes?.retrieve?.value;
	const cartId = props?.inputAttributes?.extId?.value;
	const signature = props?.inputAttributes?.signature?.value;
	const flow = props?.inputAttributes?.flowType?.value;
	const [t, setT] = useState(null);
	//const { t } = useTranslation(["app"]);

	//const appAEMContent = t("app", { ns: "app", returnObjects: true });

	const handler = (e) => {

		setShowProspectWidgets(true);
	};
	useEffect(() => {
		if (!window.location.hostname.includes('localhost')) {
			const scriptElem = document.createElement("script");
			scriptElem.type = "text/javascript";
			scriptElem.defer = true;
			scriptElem.src = process.env.PROSPECT_WIDGETS_APP_MINI_CART_SCRIPT;
			document.body.appendChild(scriptElem);
		}
	}, [])

	useEffect(() => {
		props?.fromProspect && loadChatScript();
		dispatch(setClientId(props.clientName));
		window?.sessionStorage?.setItem("fromProspect", props?.fromProspect);
		if (!props?.fromProspect && !pageNameParam) {
			// dispatch(setLoadShoppingCartWidget(false));
			// dispatch(setLoadFWAQualifiedPlans(false));
			// dispatch(setLoadCheckoutWidget(false));
			// dispatch(setLoadAddonPage(false));
			// dispatch(setLoadQualficationSelection(false));
			// dispatch(setLoadMobilityProductDetails(false));
			// dispatch(setLoadConfirmationWidget(false));
			// dispatch(setLoadBulkOrder(false));
			// dispatch(setLoadCompleteOrder(false));
			// dispatch(setLoadBulkUpload(false));
			if (props?.type !== "softwares") {
				dispatch(resetGlobalSlice());
				dispatch(resetBussProductsSlice());
				dispatch(resetCreditSlice());
				dispatch(resetReviewSlice());
				dispatch(resetPaymentSlice());
				dispatch(resetCheckoutState());
				dispatch(resetLowerFunnelSlice());
				dispatch(resetQualificationSlice());
				dispatch(resetAddonsState());
				dispatch(resetbulkUploadSlice());
				dispatch(setSessionCartData({}));
				// !props?.inputAttributes?.extId?.value && dispatch(clear4g5gCart());
			}
		}
		//dispatch(getGeoLocation())
		dispatch(setWidgetInputParams(props?.inputAttributes));
		// const moveInfo = { "GON": "MB3000011886146", "accountNumber": "407489984-00001", "mtnList": ["6158065187"], "collectionCodeMtnsMap": { "6158065187": "4GBIU" } };
		// window?.sessionStorage?.setItem("MOVERINFO", JSON.stringify(moveInfo));
		const moverInfo = JSON.parse(window?.sessionStorage?.getItem("MOVERINFO"));
		const cpcInfo = JSON.parse(window?.sessionStorage?.getItem("CPCINFO"));
		if (moverInfo) {
			dispatch(setManageServiceInfo(moverInfo));
		}
		else if (cpcInfo) {
			dispatch(setManageServiceInfo(cpcInfo));
		}
		getMVBDetails();

		if (window) {
			loadScript(process.env.PROSPECT_WIDGETS_APP_PIE_ENCRYPTION);
			loadScript(process.env.PROSPECT_WIDGETS_APP_PIE_GATEWAY);
			loadScript(process.env.PROSPECT_WIDGETS_APP_SONGBIRD);
		}
		if (!props?.type) {
			window.addEventListener("showProspectWidgets", handler);
		}
		return () => {
			if (!props?.type) {
				window.removeEventListener("showProspectWidgets", handler);
			}
		};
	}, []);
	useEffect(() => {
		if (!globalData?.widgetInputParams) dispatch(setWidgetInputParams(props?.inputAttributes));
	}, [props?.inputAttributes])

	useEffect(() => {
		if (props?.inputAttributes?.extId?.value) {
			dispatch(clear4g5gCart({ launchType: "new" }));
			//dispatch(getAEMInformation({ type: "app/MBT" }));
		}
		if (props?.inputAttributes?.clientName?.value === "MBT") {
			dispatch(initializeMfe());
		}
	}, []);
	const onCartIconClick = () => {
		setTimeout(() => {
			const eventL = new Event('mini-cart-icon-clicked')
			window.dispatchEvent(eventL)
		}, 1000)
	}

	useEffect(() => {
		if (
			lqData?.clear4g5gCartResp?.success &&
			props?.inputAttributes?.extId?.value && !globalData?.loading
		) {
			const cartmeta = {
				signature: signature,
				zipCode: "",
				flow: flow,
				clientId: props?.inputAttributes?.clientName?.value ?? window?.mbtGlobal?.clientId ?? "MBT",
				mfeShoppingPath: window?.mbtGlobal?.shoppingPath,
				userId: props?.inputAttributes?.mbloginid?.value ? props?.inputAttributes?.mbloginid?.value : window?.mbtGlobal?.userId,
				ecpdId: props?.inputAttributes?.ecpdId?.value ?? window?.mbtGlobal?.ecpdId
				//email: props?.inputAttributes?.mbauseremail?.value ?? window?.mbtGlobal?.userEmail
			};


			dispatch(getFetchCart5G({ retrieve, cartId, signature, flow, autoSavedCart: true, cartmeta }));

			dispatch(setClear4g5gCartResp({}));
		}
	}, [
		cartId,
		lqData?.clear4g5gCartResp?.success, globalData?.loading]);

	if (cartId ? shoppingCartData?.fetchCartStatus?.success : (!!props?.type || showProspectWidgets)) {
		return (
			<>
				<div id="mck-crt-icon-id" className="mock-crt-icon" onClick={() => { onCartIconClick() }}></div>
				{(window.localStorage.getItem("clientName") || globalData?.clientId) ?
					<prospect-mini-cart></prospect-mini-cart> : <></>}
				<div className="widget-warpper">
					<VDSManager>
						{/* {props?.type === "WCMP" ? <MarketplaceWCMP /> 
					: props?.type === "fwa" ? <MarketplaceFWA currentFlow={props?.inputAttributes?.currentFlow?.value} /> 
					: props?.type === "softwares" ? <MarketplaceGridwallWidget ecpd={props?.ecpd} flow={props.flow} clientId={props.clientId} fromProspect={props?.fromProspect} selectedPack={props?.selectedPack}/> 
					: props?.type === "marketplace" ? <MarketplaceWidget flow={props.flow} clientId={props.clientId} /> 
					: props?.type === "newline" ? <AddALineWidget ecpd={props?.ecpd} flow={props?.flow} clientId={props?.clientId} />
					: <></>} */}
						<WidgetRouter entryPoint={props?.type} {...props} />
					</VDSManager>
				</div>
			</>
		);
	} else if (cartId && !shoppingCartData?.fetchCartStatus) {
		return <SpinnerComponent />
	} else if (cartId && !shoppingCartData?.fetchCartStatus.success) {
		return <Notification
			type="error"
			title="Something went wrong, please wait 10 seconds and then refresh the page."
			fullBleed={true}
			inlineTreatment={false}
		/>
	}
	return <></>;
}

export default WidgetsDecider;
